import { createFileRoute } from "@tanstack/react-router";
import { PlatformPage } from "@/components/PlatformPage";
import { sellasist } from "@/lib/platforms-data";
import { buildSeoMeta } from "@/lib/seo";

const PATH = "/platformy/sellasist";

export const Route = createFileRoute("/platformy/sellasist")({
  head: () =>
    buildSeoMeta({
      title: "Wdrożenia SellAsist — integracje Allegro, Amazon, ERP | SyncTech",
      description:
        "Wdrożenia SellAsist krok po kroku. Sprzedaż wielokanałowa: Allegro, Amazon, Empik, Kaufland. Automatyzacja ofert, repricer, integracje z księgowością i kurierami. Bezpłatna wycena.",
      path: PATH,
    }),
  component: () => <PlatformPage data={sellasist} path={PATH} breadcrumbCategory="Platformy" />,
});
